import React, { Component } from 'react';

import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import Box from '../ui/Box';

import DataService from '../../services/DataService'; var ds = DataService;

export default class NewUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: this.props.details ? this.props.details.email : "",
      password: "",
      name: this.props.details ? this.props.details.name : '',
      phone: this.props.details ? this.props.details.phone : '',
      role: this.props.details && this.props.details.roles ? this.props.details.roles[0] : "reception",
      old_role: this.props.details && this.props.details.roles ? this.props.details.roles[0] : "reception",
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        all_services: [],
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
    }
  }

  componentDidMount() {
    this.getAllServices();
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  getAllServices() {
    ds.getAllServices(
      data => {
        this.setState({
          all_services: data
        }, () => {
          if (this.props.details._id) {
            this.getMyServices();
          }
        })

      }, err => {}
    );
  }

  getMyServices() {
    if (this.props.details.accessible_service && this.props.details.accessible_service.length) {
      let all_services = this.state.all_services;
      for (let i of all_services) {
        if (this.props.details.accessible_service.indexOf(i._id) != -1) {
          i.enabled = true;
        }
      }
      this.setState({ all_services })
    }

  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }

  createUser(e) {
    e.preventDefault()
    if (this.validated()) {
      let accessible_service = [];
      for (let i of this.state.all_services) {
        if (i.enabled) {
          accessible_service.push(i._id);
        }
      }
      if (this.props.details) {
        ds.postEditUser({
          hotelUserId: this.props.details._id,
          email: this.state.email,
          password: this.state.password,
          name: this.state.name,
          phone: this.state.phone,
          role: this.state.role,
          old_role: this.state.old_role,
          accessible_service: accessible_service

        }, data => {
          this.props.unMountMe(true);

        }, err => {
          this.setState({
            spinner: null
          });
        })

        if (this.state.password) {
          ds.postChangeUserPassword({
            newPassword: this.state.password,
            email: this.state.email
          },
            data => {}, 
            err => {}
          );
        }

      } else {
        ds.postCreateUser({
          email: this.state.email,
          password: this.state.password,
          name: this.state.name,
          phone: this.state.phone,
          role: this.state.role,
          accessible_service

        }, data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "User Created",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          let evt = new CustomEvent('updateUserTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            email: "",
            password: "",
            name: "",
            phone: "",
            dialog: dialog
          });

        }, err => {
          this.setState({
            spinner: null
          });
        })
      }
    }
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.name || !this.state.email || (!this.state.password && !this.props.details) || !this.state.phone || !this.state.role) {
      dialog = {
        open: true,
        head: 'Invalid',
        body: "All fields are required",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }
    if (!flag) {
      this.setState({
        dialog: dialog
      });
    }
    return flag;
  }

  render() {
    return (
      <Box header={this.props.details ? 'Edit User' : 'New User'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form onSubmit={this.createUser.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Name"
                  name="name"
                  className="w-100"
                  value={this.state.name}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Email"
                  name="email"
                  className="w-100"
                  value={this.state.email}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Password"
                  name="password"
                  type="password"
                  className="w-100"
                  value={this.state.password}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Phone"
                  name="phone"
                  className="w-100"
                  type="number"
                  value={this.state.phone}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <SelectField
                  floatingLabelText="Role"
                  value={this.state.role}
                  name="role"
                  className="w-100"
                  onChange={(e, ind, val) => {
                    this.setState({
                      role: val
                    })
                  }} >
                  <MenuItem value="hotel_admin" primaryText="Hotel Admin" />
                  <MenuItem value="reception" primaryText="Receptionist" />
                  <MenuItem value="service_manager" primaryText="Service Manager" />
                </SelectField>
              </section>

              <br />

             {this.state.role !="reception" && <div className="false-placeholder">Service Access</div>}
              
              <section>
                {
                  this.state.role !="reception" && this.state.all_services && this.state.all_services.length ?
                    this.state.all_services.map((service, ind) => {
                      return <Checkbox type="checkbox" name="remember" checked={service.enabled}
                        onCheck={
                          (e) => {
                            let x = this.state.all_services;
                            x[ind].enabled = e.target.checked;
                            this.setState({
                              all_services: x
                            })
                          }
                        } 
                        label={service.name} 
                      />
                    }) 
                  : null
                }
              </section>
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />
              <span className="space"></span>
              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>

        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/users/NewUser.js